import styles from "./File.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ArrowDownToBaseIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowDownToBaseIconPath";
import { formatFileSize } from "@coworker/apprestructured/src/shared/helpers/formatFileSize";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

type FileProps = {
  file: File;
  disabled: boolean;
  onDownloadClick: (file: File) => void;
};

export const File = ({ file, disabled, onDownloadClick }: FileProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["file"]}>
      <FixaButton
        iconOnly
        ssrIcon={ArrowDownToBaseIconPath}
        disabled={disabled}
        onClick={() => onDownloadClick(file)}
        size="small"
        aria-label={`${t("downloadString")} ${file.name}`}
      />
      <div>
        <FixaText textStyle="Heading.XS" className={styles["fileName"]}>
          {file.name}
        </FixaText>
        <FixaText textStyle="Body.M">{formatFileSize(file.size)}</FixaText>
      </div>
    </div>
  );
};
